import Box from '@/components/UI/box/Box';
import styles from './BundleBanner.module.scss';
import Typography from '@/components/UI/typography/Typography';
import Image from 'next/image';
import celebrateIcon from '@/public/images/bundle-icon/celebrate-icon.webp';
import { FC } from 'react';
import { DiscountMotivation } from '@/components/search/_types/searchDataType';
interface BundleBannerProps {
  data: DiscountMotivation;
}
const BundleBanner: FC<BundleBannerProps> = ({
  data
}) => {
  return <Box className={styles['bundle-banner']} data-sentry-element="Box" data-sentry-component="BundleBanner" data-sentry-source-file="BundleBanner.tsx">
      <Box className={styles['bundle-banner-container']} data-sentry-element="Box" data-sentry-source-file="BundleBanner.tsx">
        <Box className={styles['icon']} data-sentry-element="Box" data-sentry-source-file="BundleBanner.tsx">
          <Image src={celebrateIcon} alt={'bundle'} width={24} height={24} data-sentry-element="Image" data-sentry-source-file="BundleBanner.tsx" />
        </Box>
        <Typography variant="bodyM" data-sentry-element="Typography" data-sentry-source-file="BundleBanner.tsx">
          رزرو این اقامتگاه ها{' '}
          <Typography variant="bodyM_Bold" data-sentry-element="Typography" data-sentry-source-file="BundleBanner.tsx">
            {data?.total_discount_amount}
          </Typography>{' '}
          تومان هدیه داره!
        </Typography>
      </Box>
    </Box>;
};
export default BundleBanner;